module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/secondStep-a16bcc7179b322444580a2ac17e19c92.png";